import { render } from "./EntraReports.vue?vue&type=template&id=24672170&scoped=true"
import script from "./EntraReports.vue?vue&type=script&lang=js"
export * from "./EntraReports.vue?vue&type=script&lang=js"

import "./EntraReports.vue?vue&type=style&index=0&id=24672170&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24672170"]])

export default __exports__